module.exports = __webpack_public_path__ + "static/media/partner_purebites.6f8062ec.png";